const arCommon = {
  welcome: "مرحباً",
  language: "اللغة",
  save: "حفظ",
  rolesManagement: "ادارة الأدوار والصلاحيات",
  platformManager: "مدير المنصة",
  companies: "الشركات",
  users: "المستخدمين",
  createRole: "اضافة دور",
  fillRoleData: "ادخل معلومات الدور الجديد",
  addCompany: "إضافة شركة",
  editCompany: "تعديل الشركة",
  companyFormSubtitle: "التفاصيل والمعلومات الأساسية",
  mainInformation: "المعلومات الأساسية",
  attachments: "المرفقات",
  cancel: "إلغاء",
  close: "إغلاق",
  create: "إنشاء",
  update: "تحديث",
  somethingWentWrong: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  companyNameEnglish: "اسم الشركة بالانجليزية",
  companyNameArabic: "اسم الشركة بالعربية",
  enterNameEnglish: "أدخل اسم الشركة باللغة الإنجليزية",
  enterNameArabic: "أدخل اسم الشركة باللغة العربية",
  address: "العنوان",
  email: "البريد الإلكتروني",
  enterEmail: "أدخل بريدك الإلكتروني",
  phoneNumber: "رقم الهاتف",
  companyPhoneNumber: "رقم هاتف الشركة",
  fax: "الفاكس",
  faxPlaceholder: "الفاكس",
  notes: "ملاحظات",
  notesPlaceholder: "ملاحظات أو تفاصيل",
  delete: "حذف",
  confirmDeleteCompanyAdmin: "هل أنت متأكد أنك تريد حذف مسؤول الشركة؟",
  deleteWarning: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
  typeDeleteToConfirm: 'اكتب "{{deleteWord}}" لتأكيد الحذف',
  company: "الشركة",
  selectCompany: "اختر الشركة",
  companyName: "اسم الشركة",
  createAdmin: "انشاء مسئول حساب",
  adminDetails: "التفاصيل والمعلومات الأساسية",
  companyManagement: "الشركات",
  subscriptions: "الإشتراكات",
  SubscriptionSubTitle: "إدارة الاشتراكات  وحدود التراخيص الخاصة بالشركات.",
  createSubscriptions: "إضافة اشتراك جديد",
  search: "بحث",
  selectSearchPlaceholder: "بحث...",
  selectNoResults: "لا توجد نتائج.",
  addSubscription: "إضافةاشتراك",
  subscripeSubTitle: "إنشاء الاشتراك وتحديد حدود التراخيص الخاصة بالشركة.",
  chooseCompany: "إختار الشركة",
  noChoice: "لا توجد خيارات",
  moduleSubscriptions: "الإشتراكات",
  totalPrice: "إجمالى السعر",
  view: "عرض",
  edit: "تعديل",
  searchMaxLength: "أقصى عدد من الحروف 100",
  searchInvalid: "لا يمكن البحث بنص فارغ",
  modules: "الأنظمة",
  moduleSub:
    "اختر الانظمه المشمولة في هذا الاشتراك. يمكن تعديل الأسعار حسب الحاجة",
  price: "السعر",
  durations: "المده",
  startDate: "تاريخ البداية",
  endDate: "تاريخ النهاية",
  yearly: "سنوى",
  monthly: "شهرى",
  areYouSureToLogout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
  youWillBeLoggedOut: "سيتم الخروج من الحساب",
  logout: "تسجيل الخروج",
  duration: "المدة",
  companyDetail: "الاشتراك وتحديد حدود التراخيص الخاصة بالشركة.",
  history: "السابق",
  current: "الحالى",
  future: "القادم",
  companyInfo: "تفاصيل الشركة",
  companyName2: "اسم الشركة",
  searchCompanyName: "بحث",
  noCompaniesFound: "لا يوجد شركات",
  welcomeBack: "مرحباً بعودتك!",
  pleaseEnterCredentials: "من فضلك أدخل بياناتك لتسجيل الدخول",
  userName: "اسم المستخدم",
  password: "كلمة المرور",
  didYouForgotPassword: "هل نسيت كلمة المرور!",
  sessionTimedOut: "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
  noModulesFound: "لا توجد أنظمة",
  emptyHistoryMessage: "لا توجد اشتراكات سابقة",
  emptyCurrentMessage: "لا توجد اشتراكات حالية",
  emptyFutureMessage: "لا توجد اشتراكات قادمة",
  addAttachment: "اضافة مرفقات ",
  companyAttachments: {
    maxFiles: "يسمح بحد أقصى {{count}} مرفقات.",
    maxFileSize:
      'حجم الملف "{{fileName}}" يتجاوز الحد الأقصى وهو {{size}} ميجابايت.',
  },
  companyNameArRequired: "اسم الشركة باللغة العربية مطلوب.",
  companyNameEnRequired: "اسم الشركة باللغة الإنجليزية مطلوب.",
  nameEnRequired: "الاسم باللغة الإنجليزية مطلوب.",
  nameArRequired: "الاسم باللغة العربية مطلوب.",
  emailRequired: "البريد الإلكتروني مطلوب.",
  phoneNumberRequired: "رقم الهاتف مطلوب.",
  invalidPhoneNumber: "رقم الهاتف غير صالح.",
  phoneNumberDigitsOnly: "رقم الهاتف يجب أن يحتوي على أرقام فقط.",
  invalidSaudiPhoneNumber:
    "رقم الهاتف السعودي يجب أن يتكون من 9 أرقام ويبدأ بالرقم 5.",
  invalidEgyptPhoneNumber:
    "رقم الهاتف المصري يجب أن يتكون من 10 أرقام ويبدأ بـ 10 أو 11 أو 12 أو 15.",
  invalidUaePhoneNumber:
    "رقم الهاتف الإماراتي يجب أن يتكون من 9 أرقام ويبدأ بالرقم 5.",
  invalidJordanPhoneNumber:
    "رقم الهاتف الأردني يجب أن يتكون من 9 أرقام ويبدأ بالرقم 7.",
  updateSub: "حفظ التعديلات",
  halfYear: "نصف سنوى",
  saudiRiyal: "ريال سعودي",
  active: "نشط",
  companyNameAr: "اسم الشركة بالعربية",
  nameAr: "الاسم بالعربية",
  nameEn: "الاسم بالانجليزية",
  loading: "جاري التحميل",
  username: "اسم المستخدم",
  companyAdminNameArRequired: "الاسم باللغة العربية مطلوب.",
  companyAdminNameEnRequired: "الاسم باللغة الإنجليزية مطلوب.",
  usernameRequired: "اسم المستخدم مطلوب.",
  invalidUsername:
    "اسم المستخدم يجب أن يكون من 3 إلى 30 حرفاً ويحتوي على أحرف أو أرقام فقط.",
  companyRequired: "اسم الشركة مطلوب",
  inactive: "غير نشط",
  duplicateFile: 'تمت إضافة الملف "{{fileName}}" مسبقًا.',
  noDuration: "لا يوجد",
  pendingActivation: "قيد التفعيل",
  status: "الحالة",
  name: "الاسم",
  linkedCompany: "الشركة المرتبطة",
  activateAccount: "تفعيل الحساب",
  confirmResendActivationLink:
    "هل تريد  إعادة إرسال بريد تفعيل الحساب إلى المستخدم؟",
  resendActivationLink: "إعادة إرسال رابط التفعيل",
  resendActivationLinkDescription:
    "سيتم إرسال رابط تفعيل جديد إلى البريد الإلكتروني المسجل، ويمكن للمستخدم استخدامه لتفعيل حسابه.",
  activationLinkSent: "تم إرسال رابط التفعيل بنجاح.",
  resendActivationLinkFailed: "فشل في إعادة إرسال رابط التفعيل.",
  confirm: "تأكيد",
  extend: "تمديد",
  openNavigation: "فتح قائمة التنقل",
  closeNavigation: "إغلاق قائمة التنقل",
  primaryNavigation: "التنقل الرئيسي",
  notifications: "الإشعارات",

  tenantNotFound: {
    title: "404",
    description: "لا يوجد مساحة عمل مسجلة على هذا العنوان.",
  },

  businessModules: {
    core: "الرئيسية",
    fleetMonitoring: "الأسطول",
    operations: "العمليات",
    workforce: "القوى العاملة",
    maintenance: "الصيانة",
    partsAndInventory: "قطع الغيار والمخزون",
    analyticsAndInsights: "التحليلات والرؤى",
    communications: "الاتصالات",
  },
  datePicker: {
    pickDay: "اختار اليوم :",
    pickPeriod: "اختار الفترة :",
    close: "إغلاق",
    save: "حفظ",
    cancel: "إلغاء",
    time: "الوقت",
    hours: "الساعات",
    minutes: "الدقائق",
    am: "صباحا",
    pm: "مساء",
  },
  overCapacity: {
    title: {
      subscription: "الأنظمة تتجاوز الحد المتاح",
      device: "الأجهزة تتجاوز الحد المتاح",
    },
    heading: {
      subscription: "بعض الأنظمة تتجاوز الحد المتاح",
      device: "الأجهزة تتجاوز الحد المتاح",
    },
    message: {
      createSubscription:
        "عدد الأجهزة أو المستخدمين في الأنظمة التالية أكبر من العدد المتاح في الاشتراك. سيتم إنشاء الاشتراك، وسيتم احتساب الزيادة كرسوم إضافية.",
      updateSubscription:
        "عدد الأجهزة أو المستخدمين في الأنظمة التالية أكبر من العدد المتاح في الاشتراك. سيتم إضافة الأنظمة، وسيتم احتساب الزيادة كرسوم إضافية.",
      createDevice:
        "جميع الأجهزة المتاحة في الاشتراك مستخدمة. سيتم إنشاء الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
      restoreDevice:
        "جميع الأجهزة المتاحة في الاشتراك مستخدمة. سيتم استعادة الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
      activateDevice:
        "جميع الأجهزة المتاحة في الاشتراك مستخدمة. سيتم تفعيل الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
    },
    notice: {
      createSubscription:
        "عدد الأجهزة أو المستخدمين في الأنظمة التالية أصبح أكبر من العدد المتاح في الاشتراك. تم إنشاء الاشتراك، وسيتم احتساب الزيادة كرسوم إضافية.",
      updateSubscription:
        "عدد الأجهزة أو المستخدمين في الأنظمة التالية أصبح أكبر من العدد المتاح في الاشتراك. تمت إضافة الأنظمة، وسيتم احتساب الزيادة كرسوم إضافية.",
      createDevice:
        "كانت جميع الأجهزة المتاحة في الاشتراك مستخدمة. تم إنشاء الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
      restoreDevice:
        "كانت جميع الأجهزة المتاحة في الاشتراك مستخدمة. تمت استعادة الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
      activateDevice:
        "كانت جميع الأجهزة المتاحة في الاشتراك مستخدمة. تم تفعيل الجهاز، وسيتم احتساب الزيادة كرسوم إضافية.",
    },
    columns: {
      subscription: "النظام",
      device: "البند",
      paid: "المتاح",
      current: "الحالي",
      additional: "الزيادة",
    },
    devices: "الأجهزة",
    totalAdditional: "إجمالي الوحدات الزائدة",
    fees: {
      title: "الرسوم الإضافية المتوقعة",
      note: {
        subscription: "تُحتسب حسب سعر الوحدة المعتمد لكل نظام",
        device: "تُحتسب حسب السعر المعتمد لكل جهاز",
      },
    },
    cancel: "إلغاء",
    ok: "حسناً",
    confirm: {
      createSubscription: "تأكيد الإنشاء",
      updateSubscription: "تأكيد الحفظ",
      createDevice: "تأكيد الإنشاء",
      restoreDevice: "تأكيد الاستعادة",
      activateDevice: "تأكيد التفعيل",
    },
    close: "إغلاق تحذير تجاوز الحد المتاح",
  },
};

export default arCommon;
